import React from "react";
import IcoMoon, { IcoMoonProps } from "react-icomoon";
import iconSet from "./selection2.json";

interface IconMoonProps extends Omit<IcoMoonProps, "iconSet"> {
  icon: string;
}

const IconMoon = ({ icon, ...rest }: IconMoonProps) => {
  const normalizedIcon = icon.toLowerCase();
  return (
    <IcoMoon iconSet={iconSet} size={20} icon={normalizedIcon} {...rest} />
  );
};

export default IconMoon;
